const React = require('react');
const T = require('prop-types');
const { useState, useEffect } = React;
const { context } = require('app-context');

const styledModule = require('styled-components');
const styled = styledModule.default || styledModule;
const { MAX_CONTENT_WIDTH } = require('utils/constants');
const FormConfig = require('./formConfig');

const { default: Box } = require('@mui/material/Box');
const { default: Typography } = require('@mui/material/Typography');
const { default: Button } = require('@mui/material/Button');
const { default: Chip } = require('@mui/material/Chip');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: CircularProgress } = require('@mui/material/CircularProgress');
const { default: Table } = require('@mui/material/Table');
const { default: TableBody } = require('@mui/material/TableBody');
const { default: TableCell } = require('@mui/material/TableCell');
const { default: TableHead } = require('@mui/material/TableHead');
const { default: TableRow } = require('@mui/material/TableRow');
const { default: Paper } = require('@mui/material/Paper');
const { default: TableContainer } = require('@mui/material/TableContainer');
const { default: AddIcon } = require('@mui/icons-material/Add');
const { default: EditIcon } = require('@mui/icons-material/Edit');
const { default: BlockIcon } = require('@mui/icons-material/Block');

const api = context.api.nearpeer;

const FullWidthWrapper = styled.div`
    position: absolute;
    min-width: 100vw;
    left: calc(((100vw - ${MAX_CONTENT_WIDTH}px) / 2) * -1);
    top: 0;
    background-color: white;
    min-height: 100%;

    @media (max-width: ${MAX_CONTENT_WIDTH}px) {
        left: 0;
        width: 100%;
    }
`;

const STATUS_COLORS = {
    approved: 'success',
    draft: 'default',
    pending: 'warning',
    rejected: 'error',
    disabled: 'error'
};

module.exports = function AdminOffersListPage(props) {

    const { history } = props;

    const [offers, setOffers] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {

        api.offers.adminList()
            .then(({ entities, result: ids }) => {

                const list = (ids || []).map((id) => entities.offers[id]).filter(Boolean);
                setOffers(list);
            })
            .catch((err) => setError(err.message || 'Failed to load offers'));
    }, []);

    const handleDisable = async (id) => {

        if (!window.confirm('Disable this offer?')) {
            return;
        }

        await api.offers.adminDelete(id);
        setOffers((prev) => prev.map((o) => o.id === id ? { ...o, status: 'disabled' } : o));
    };

    if (error) {
        return (
            <FullWidthWrapper>
                <Box sx={{ p: 3 }}>
                    <Typography color='error'>{error}</Typography>
                </Box>
            </FullWidthWrapper>
        );
    }

    if (offers === null) {
        return (
            <FullWidthWrapper>
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                    <CircularProgress />
                </Box>
            </FullWidthWrapper>
        );
    }

    return (
        <FullWidthWrapper>
        <Box sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant='h5' sx={{ fontWeight: 700 }}>Manage Offers</Typography>
                <Button
                    variant='contained'
                    startIcon={<AddIcon />}
                    onClick={() => history.push('/app/admin/offers/create')}
                >
                    New Offer
                </Button>
            </Box>
            <TableContainer component={Paper} elevation={1}>
                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Brand</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Priority</TableCell>
                            <TableCell>Targets</TableCell>
                            <TableCell>Start</TableCell>
                            <TableCell>End</TableCell>
                            <TableCell align='right'>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {offers.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Typography color='text.secondary' sx={{ textAlign: 'center', py: 2 }}>
                                        No offers yet. Click "New Offer" to create one.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {offers.map((offer) => (
                            <TableRow key={offer.id} hover>
                                <TableCell>{offer.brandName}</TableCell>
                                <TableCell>{offer.title}</TableCell>
                                <TableCell>
                                    <Chip
                                        label={offer.status}
                                        color={STATUS_COLORS[offer.status] || 'default'}
                                        size='small'
                                    />
                                </TableCell>
                                <TableCell>{offer.priority}</TableCell>
                                <TableCell>{
                                    (offer.targets || []).some((t) => t.targetType === 'schoolRole' && String(t.targetValue).startsWith('all:'))
                                        ? 'all'
                                        : (offer.targets ? offer.targets.length : 0)
                                }</TableCell>
                                <TableCell>{offer.startDate ? new Date(offer.startDate).toLocaleDateString() : '—'}</TableCell>
                                <TableCell>{offer.endDate ? new Date(offer.endDate).toLocaleDateString() : '—'}</TableCell>
                                <TableCell align='right'>
                                    <IconButton
                                        size='small'
                                        onClick={() => history.push(FormConfig.getOfferEditPath(offer))}
                                        aria-label='Edit offer'
                                    >
                                        <EditIcon fontSize='small' />
                                    </IconButton>
                                    {offer.status !== 'disabled' && (
                                        <IconButton
                                            size='small'
                                            onClick={() => handleDisable(offer.id)}
                                            aria-label='Disable offer'
                                            color='error'
                                        >
                                            <BlockIcon fontSize='small' />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
        </FullWidthWrapper>
    );
};

module.exports.propTypes = {
    history: T.object
};
